/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'astro/server/entity';

import BasicStatusProxy from 'astro/server/unit/basic.status.proxy';


export default class extends Entity
{
  makeStatusProxy ()
  {
    return new BasicStatusProxy(this);
  }


  installPassiveBenefit ()
  {
    // no-op.
  }


  installActiveBenefit ()
  {
    // no-op.
  }


}
